package br.com.vvrefeicoes.portal.feature.orgchart

import androidx.compose.foundation.BorderStroke
import androidx.compose.foundation.Canvas
import androidx.compose.foundation.background
import androidx.compose.foundation.gestures.detectDragGestures
import androidx.compose.foundation.horizontalScroll
import androidx.compose.foundation.hoverable
import androidx.compose.foundation.interaction.MutableInteractionSource
import androidx.compose.foundation.interaction.collectIsHoveredAsState
import androidx.compose.foundation.layout.Arrangement
import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.BoxWithConstraints
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.ColumnScope
import androidx.compose.foundation.layout.ExperimentalLayoutApi
import androidx.compose.foundation.layout.FlowRow
import androidx.compose.foundation.layout.IntrinsicSize
import androidx.compose.foundation.layout.PaddingValues
import androidx.compose.foundation.layout.Row
import androidx.compose.foundation.layout.fillMaxHeight
import androidx.compose.foundation.layout.fillMaxSize
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.height
import androidx.compose.foundation.layout.heightIn
import androidx.compose.foundation.layout.offset
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.layout.size
import androidx.compose.foundation.layout.width
import androidx.compose.foundation.rememberScrollState
import androidx.compose.foundation.shape.CircleShape
import androidx.compose.foundation.shape.RoundedCornerShape
import androidx.compose.foundation.verticalScroll
import androidx.compose.material3.Checkbox
import androidx.compose.material3.CircularProgressIndicator
import androidx.compose.material3.DropdownMenu
import androidx.compose.material3.DropdownMenuItem
import androidx.compose.material3.HorizontalDivider
import androidx.compose.material3.Icon
import androidx.compose.material3.IconButton
import androidx.compose.material3.MaterialTheme
import androidx.compose.material3.Surface
import androidx.compose.material3.Text
import androidx.compose.runtime.Composable
import androidx.compose.runtime.DisposableEffect
import androidx.compose.runtime.LaunchedEffect
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.rememberUpdatedState
import androidx.compose.runtime.setValue
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.draw.alpha
import androidx.compose.ui.geometry.Offset
import androidx.compose.ui.geometry.Rect
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.graphics.vector.ImageVector
import androidx.compose.ui.input.pointer.pointerInput
import androidx.compose.ui.layout.boundsInWindow
import androidx.compose.ui.layout.onGloballyPositioned
import androidx.compose.ui.layout.positionInWindow
import androidx.compose.ui.text.style.TextAlign
import androidx.compose.ui.text.style.TextOverflow
import androidx.compose.ui.unit.IntOffset
import androidx.compose.ui.unit.dp
import androidx.compose.ui.window.Dialog
import br.com.vvrefeicoes.portal.core.di.rememberSessionPermissions
import br.com.vvrefeicoes.portal.core.model.ScreenMode
import br.com.vvrefeicoes.portal.core.ui.components.AppBadge
import br.com.vvrefeicoes.portal.core.ui.components.AppButton
import br.com.vvrefeicoes.portal.core.ui.components.AppFooter
import br.com.vvrefeicoes.portal.core.ui.components.AppTextField
import br.com.vvrefeicoes.portal.core.ui.components.AppToast
import br.com.vvrefeicoes.portal.core.ui.components.EmptyState
import br.com.vvrefeicoes.portal.core.ui.components.MultiSelectField
import br.com.vvrefeicoes.portal.core.ui.components.PortalButtonVariant
import br.com.vvrefeicoes.portal.core.ui.components.SearchableSelect
import br.com.vvrefeicoes.portal.core.ui.components.SelectOption
import br.com.vvrefeicoes.portal.core.ui.components.SuccessDialog
import br.com.vvrefeicoes.portal.core.ui.layout.AppScrollColumn
import br.com.vvrefeicoes.portal.core.ui.layout.AppScrollbar
import br.com.vvrefeicoes.portal.core.ui.theme.AppPalette
import br.com.vvrefeicoes.portal.core.ui.theme.AppShapes
import br.com.vvrefeicoes.portal.core.ui.theme.AppSpacing
import br.com.vvrefeicoes.portal.core.ui.theme.PortalTheme
import br.com.vvrefeicoes.portal.core.util.PdfWriter
import br.com.vvrefeicoes.portal.core.util.encodeBase64
import br.com.vvrefeicoes.portal.core.util.isPdfExportSupported
import br.com.vvrefeicoes.portal.core.util.savePdf
import br.com.vvrefeicoes.portal.core.util.toPdfImage
import br.com.vvrefeicoes.portal.domain.model.Company
import br.com.vvrefeicoes.portal.domain.model.CompanyType
import br.com.vvrefeicoes.portal.domain.model.Manager
import br.com.vvrefeicoes.portal.domain.model.OrgChartChange
import br.com.vvrefeicoes.portal.domain.model.OrgChartStatus
import br.com.vvrefeicoes.portal.domain.model.OrgChartVersion
import br.com.vvrefeicoes.portal.domain.model.PermissionAction
import br.com.vvrefeicoes.portal.domain.model.PermissionKeys
import br.com.vvrefeicoes.portal.domain.model.allows
import br.com.vvrefeicoes.portal.navigation.AdminCompaniesRoute
import br.com.vvrefeicoes.portal.navigation.AdminUsersRoute
import com.composables.icons.lucide.ArrowLeft
import com.composables.icons.lucide.ArrowRightLeft
import com.composables.icons.lucide.Building
import com.composables.icons.lucide.CircleOff
import com.composables.icons.lucide.Copy
import com.composables.icons.lucide.Download
import com.composables.icons.lucide.EllipsisVertical
import com.composables.icons.lucide.History
import com.composables.icons.lucide.Info
import com.composables.icons.lucide.Lucide
import com.composables.icons.lucide.PackagePlus
import com.composables.icons.lucide.Pencil
import com.composables.icons.lucide.Plus
import com.composables.icons.lucide.Search
import com.composables.icons.lucide.Unlink
import com.composables.icons.lucide.UserPlus
import com.composables.icons.lucide.UserRound
import com.composables.icons.lucide.UserRoundCog
import com.composables.icons.lucide.Users
import com.composables.icons.lucide.X
import kotlinx.coroutines.delay
import org.jetbrains.compose.resources.painterResource
import org.jetbrains.compose.resources.stringResource
import portalvv.shared.generated.resources.Res
import portalvv.shared.generated.resources.back
import portalvv.shared.generated.resources.footer_rights
import portalvv.shared.generated.resources.logo_portal
import portalvv.shared.generated.resources.logo_vv
import portalvv.shared.generated.resources.orgchart_add
import portalvv.shared.generated.resources.orgchart_add_company
import portalvv.shared.generated.resources.orgchart_add_director
import portalvv.shared.generated.resources.orgchart_add_manager
import portalvv.shared.generated.resources.orgchart_cancel
import portalvv.shared.generated.resources.orgchart_cell_evt
import portalvv.shared.generated.resources.orgchart_cell_loj
import portalvv.shared.generated.resources.orgchart_cell_tra
import portalvv.shared.generated.resources.orgchart_cell_upr
import portalvv.shared.generated.resources.orgchart_change_company_added
import portalvv.shared.generated.resources.orgchart_change_company_linked_director
import portalvv.shared.generated.resources.orgchart_change_company_linked_directors
import portalvv.shared.generated.resources.orgchart_change_company_linked_organogram
import portalvv.shared.generated.resources.orgchart_change_company_managed
import portalvv.shared.generated.resources.orgchart_change_company_managed_in_director
import portalvv.shared.generated.resources.orgchart_change_company_managed_in_directors
import portalvv.shared.generated.resources.orgchart_change_company_removed
import portalvv.shared.generated.resources.orgchart_change_company_stopped_managed
import portalvv.shared.generated.resources.orgchart_change_company_stopped_managed_in_director
import portalvv.shared.generated.resources.orgchart_change_company_stopped_managed_in_directors
import portalvv.shared.generated.resources.orgchart_change_company_unlinked_director
import portalvv.shared.generated.resources.orgchart_change_company_unlinked_organogram
import portalvv.shared.generated.resources.orgchart_change_director_added
import portalvv.shared.generated.resources.orgchart_change_director_removed
import portalvv.shared.generated.resources.orgchart_change_manager_added
import portalvv.shared.generated.resources.orgchart_change_manager_removed
import portalvv.shared.generated.resources.orgchart_change_manager_responds
import portalvv.shared.generated.resources.orgchart_change_manager_responds_all
import portalvv.shared.generated.resources.orgchart_change_manager_stopped
import portalvv.shared.generated.resources.orgchart_changes_draft_title
import portalvv.shared.generated.resources.orgchart_changes_info_title
import portalvv.shared.generated.resources.orgchart_close
import portalvv.shared.generated.resources.orgchart_company_actions
import portalvv.shared.generated.resources.orgchart_comparing
import portalvv.shared.generated.resources.orgchart_confirm
import portalvv.shared.generated.resources.orgchart_copy_company
import portalvv.shared.generated.resources.orgchart_copy_manager
import portalvv.shared.generated.resources.orgchart_copy_support
import portalvv.shared.generated.resources.orgchart_copy_to
import portalvv.shared.generated.resources.orgchart_copy_to_director
import portalvv.shared.generated.resources.orgchart_create_version
import portalvv.shared.generated.resources.orgchart_director_actions
import portalvv.shared.generated.resources.orgchart_director_subtitle
import portalvv.shared.generated.resources.orgchart_discard_action
import portalvv.shared.generated.resources.orgchart_discard_draft
import portalvv.shared.generated.resources.orgchart_discard_draft_msg
import portalvv.shared.generated.resources.orgchart_empty_result
import portalvv.shared.generated.resources.orgchart_export
import portalvv.shared.generated.resources.orgchart_legend_kitchens
import portalvv.shared.generated.resources.orgchart_manage_supervisors
import portalvv.shared.generated.resources.orgchart_manager_actions
import portalvv.shared.generated.resources.orgchart_mark_all_companies
import portalvv.shared.generated.resources.orgchart_move_companies_too
import portalvv.shared.generated.resources.orgchart_new_version
import portalvv.shared.generated.resources.orgchart_new_version_body
import portalvv.shared.generated.resources.orgchart_no_changes_previous
import portalvv.shared.generated.resources.orgchart_no_companies
import portalvv.shared.generated.resources.orgchart_no_director_option
import portalvv.shared.generated.resources.orgchart_no_previous
import portalvv.shared.generated.resources.orgchart_not_found_company
import portalvv.shared.generated.resources.orgchart_not_found_director
import portalvv.shared.generated.resources.orgchart_not_found_manager
import portalvv.shared.generated.resources.orgchart_other_versions
import portalvv.shared.generated.resources.orgchart_period
import portalvv.shared.generated.resources.orgchart_period_until_today
import portalvv.shared.generated.resources.orgchart_previous_versions
import portalvv.shared.generated.resources.orgchart_publish_action
import portalvv.shared.generated.resources.orgchart_publish_empty
import portalvv.shared.generated.resources.orgchart_publish_success
import portalvv.shared.generated.resources.orgchart_publish_support
import portalvv.shared.generated.resources.orgchart_publish_version
import portalvv.shared.generated.resources.orgchart_register_company
import portalvv.shared.generated.resources.orgchart_register_director
import portalvv.shared.generated.resources.orgchart_register_manager
import portalvv.shared.generated.resources.orgchart_remove_company
import portalvv.shared.generated.resources.orgchart_remove_company_msg
import portalvv.shared.generated.resources.orgchart_remove_director
import portalvv.shared.generated.resources.orgchart_remove_director_msg
import portalvv.shared.generated.resources.orgchart_remove_manager
import portalvv.shared.generated.resources.orgchart_remove_manager_msg
import portalvv.shared.generated.resources.orgchart_responsible_no_director
import portalvv.shared.generated.resources.orgchart_responsible_pair
import portalvv.shared.generated.resources.orgchart_save
import portalvv.shared.generated.resources.orgchart_save_draft
import portalvv.shared.generated.resources.orgchart_search_placeholder
import portalvv.shared.generated.resources.orgchart_select_placeholder
import portalvv.shared.generated.resources.orgchart_set_director
import portalvv.shared.generated.resources.orgchart_set_responsible
import portalvv.shared.generated.resources.orgchart_subtitle_edited
import portalvv.shared.generated.resources.orgchart_subtitle_published
import portalvv.shared.generated.resources.orgchart_subtitle_valid
import portalvv.shared.generated.resources.orgchart_supervisor_col_name
import portalvv.shared.generated.resources.orgchart_supervisor_col_role
import portalvv.shared.generated.resources.orgchart_supervisor_edit
import portalvv.shared.generated.resources.orgchart_supervisor_empty
import portalvv.shared.generated.resources.orgchart_supervisor_none
import portalvv.shared.generated.resources.orgchart_supervisor_search
import portalvv.shared.generated.resources.orgchart_title
import portalvv.shared.generated.resources.orgchart_total_events
import portalvv.shared.generated.resources.orgchart_total_stores
import portalvv.shared.generated.resources.orgchart_total_transported
import portalvv.shared.generated.resources.orgchart_total_upr
import portalvv.shared.generated.resources.orgchart_transfer_company
import portalvv.shared.generated.resources.orgchart_transfer_manager
import portalvv.shared.generated.resources.orgchart_transfer_support
import portalvv.shared.generated.resources.orgchart_transfer_to
import portalvv.shared.generated.resources.orgchart_transfer_to_director
import portalvv.shared.generated.resources.orgchart_unassigned_manager
import portalvv.shared.generated.resources.orgchart_unlink_action
import portalvv.shared.generated.resources.orgchart_unlink_company
import portalvv.shared.generated.resources.orgchart_unlink_company_msg
import portalvv.shared.generated.resources.orgchart_unlink_director
import portalvv.shared.generated.resources.orgchart_unlink_director_msg
import portalvv.shared.generated.resources.orgchart_unlink_manager
import portalvv.shared.generated.resources.orgchart_unlink_manager_msg
import portalvv.shared.generated.resources.orgchart_version_current_suffix
import portalvv.shared.generated.resources.orgchart_version_info
import portalvv.shared.generated.resources.orgchart_versions_title
import portalvv.shared.generated.resources.orgchart_without_director
import portalvv.shared.generated.resources.slogan
import kotlin.math.roundToInt

private val PillWidth = 180.dp

private data class OrgMenuOption(
    val label: String,
    val icon: ImageVector,
)

private data class DraggedCompany(
    val directorId: String,
    val managerId: String?,
    val companyId: String,
    val name: String,
    val colors: PillColors,
)

private data class DraggedManager(
    val directorId: String,
    val managerId: String,
    val name: String,
    val colors: PillColors,
)

private class OrgDragController(
    private val onMoveCompany: (String, String?, String, String, String) -> Unit,
    private val onMoveManager: (String, String, String) -> Unit,
) {
    var draggedCompany by mutableStateOf<DraggedCompany?>(null)
        private set

    var draggedManager by mutableStateOf<DraggedManager?>(null)
        private set

    var pointerWindow by mutableStateOf(Offset.Zero)
        private set

    private val managerBounds = mutableMapOf<Pair<String, String>, Rect>()
    private val directorBounds = mutableMapOf<String, Rect>()

    fun registerManagerBounds(
        directorId: String,
        managerId: String,
        bounds: Rect,
    ) {
        managerBounds[directorId to managerId] = bounds
    }

    fun unregisterManagerBounds(
        directorId: String,
        managerId: String,
    ) {
        managerBounds.remove(directorId to managerId)
    }

    fun registerDirectorBounds(
        directorId: String,
        bounds: Rect,
    ) {
        directorBounds[directorId] = bounds
    }

    fun unregisterDirectorBounds(directorId: String) {
        directorBounds.remove(directorId)
    }

    fun startCompanyDrag(
        directorId: String,
        managerId: String?,
        companyId: String,
        name: String,
        colors: PillColors,
        position: Offset,
    ) {
        draggedCompany = DraggedCompany(directorId, managerId, companyId, name, colors)
        pointerWindow = position
    }

    fun startManagerDrag(
        directorId: String,
        managerId: String,
        name: String,
        colors: PillColors,
        position: Offset,
    ) {
        draggedManager = DraggedManager(directorId, managerId, name, colors)
        pointerWindow = position
    }

    fun updateDrag(position: Offset) {
        pointerWindow = position
    }

    fun endDrag() {
        draggedCompany?.let { dragged ->
            draggedCompany = null
            val (targetDirector, targetManager) =
                managerBounds.entries.firstOrNull { it.value.contains(pointerWindow) }?.key ?: return
            onMoveCompany(dragged.companyId, dragged.managerId, dragged.directorId, targetManager, targetDirector)
            return
        }
        draggedManager?.let { dragged ->
            draggedManager = null
            val targetDirector = directorBounds.entries.firstOrNull { it.value.contains(pointerWindow) }?.key ?: return
            onMoveManager(dragged.managerId, dragged.directorId, targetDirector)
        }
    }

    fun cancelDrag() {
        draggedCompany = null
        draggedManager = null
    }

    fun isOver(
        directorId: String,
        managerId: String,
    ): Boolean = draggedCompany != null && (managerBounds[directorId to managerId]?.contains(pointerWindow) ?: false)

    fun isOverDirector(directorId: String): Boolean = draggedManager != null && (directorBounds[directorId]?.contains(pointerWindow) ?: false)
}

@Composable
fun OrgChartScreen(onNavigate: (Any) -> Unit = {}) {
    val controller = rememberOrgChartController()
    val permissions = rememberSessionPermissions()
    val orgChartKey = PermissionKeys.ORG_CHART
    val canEdit = permissions.allows(orgChartKey, PermissionAction.EDIT)
    val canPublish = permissions.allows(orgChartKey, PermissionAction.CREATE)
    val version = controller.displayedVersion
    val pdfLabels =
        OrgChartPdfLabels(
            title = stringResource(Res.string.orgchart_title),
            slogan = stringResource(Res.string.slogan),
            totals =
                mapOf(
                    CompanyType.UPR to stringResource(Res.string.orgchart_cell_upr),
                    CompanyType.TRA to stringResource(Res.string.orgchart_cell_tra),
                    CompanyType.LOJ to stringResource(Res.string.orgchart_cell_loj),
                    CompanyType.EVENTOS to stringResource(Res.string.orgchart_cell_evt),
                ),
            legend =
                mapOf(
                    CompanyType.UPR to stringResource(Res.string.orgchart_legend_kitchens),
                    CompanyType.TRA to stringResource(Res.string.orgchart_total_transported),
                    CompanyType.LOJ to stringResource(Res.string.orgchart_total_stores),
                    CompanyType.EVENTOS to stringResource(Res.string.orgchart_total_events),
                ),
            rights = stringResource(Res.string.footer_rights),
        )
    val pdfLogoPortalPainter = painterResource(Res.drawable.logo_portal)
    val pdfLogoVvPainter = painterResource(Res.drawable.logo_vv)
    val drag =
        remember {
            OrgDragController(
                onMoveCompany = { companyId, fromManagerId, fromDirectorId, toManagerId, toDirectorId ->
                    val targetActive = controller.currentData.managers.any { it.id == toManagerId && !it.inactive }
                    if (targetActive) {
                        if (fromManagerId != null) {
                            controller.transferCompany(companyId, fromManagerId, fromDirectorId, toManagerId, toDirectorId)
                        } else {
                            controller.moveDirectCompany(companyId, toManagerId, toDirectorId)
                        }
                    }
                },
                onMoveManager = { managerId, fromDirectorId, toDirectorId ->
                    val targetValid =
                        toDirectorId.isEmpty() ||
                            controller.currentData.directors.any { it.id == toDirectorId && !it.inactive }
                    if (fromDirectorId != toDirectorId && targetValid) {
                        val companyIds = controller.companyIdsOfManager(managerId, fromDirectorId)
                        controller.transferManager(managerId, fromDirectorId, toDirectorId, companyIds)
                    }
                },
            )
        }
    var contentWindowPosition by remember { mutableStateOf(Offset.Zero) }

    LaunchedEffect(controller) {
        controller.init()
    }

    LaunchedEffect(controller.toastMessage) {
        if (controller.toastMessage != null) {
            delay(2500)
            controller.toastMessage = null
            controller.toastArgs = emptyList()
        }
    }

    Box(
        modifier =
            Modifier
                .fillMaxSize()
                .onGloballyPositioned { contentWindowPosition = it.positionInWindow() },
    ) {
        AppScrollColumn(
            modifier = Modifier.fillMaxSize(),
            contentPadding = PaddingValues(AppSpacing.space24),
            verticalArrangement = Arrangement.spacedBy(AppSpacing.space16),
            footer = { AppFooter() },
        ) {
            Row(
                modifier = Modifier.fillMaxWidth(),
                verticalAlignment = Alignment.CenterVertically,
                horizontalArrangement = Arrangement.SpaceBetween,
            ) {
                Row(
                    verticalAlignment = Alignment.CenterVertically,
                    horizontalArrangement = Arrangement.spacedBy(AppSpacing.space12),
                ) {
                    Text(
                        text = stringResource(Res.string.orgchart_title),
                        style = MaterialTheme.typography.headlineMedium,
                    )
                    version?.let { v ->
                        val badge = v.status.badgeColors()
                        AppBadge(
                            text = stringResource(v.status.label),
                            containerColor = badge.container,
                            contentColor = badge.content,
                        )
                    }
                }
                if (controller.isDrafting) {
                    AppButton(
                        text = stringResource(Res.string.back),
                        onClick = controller::backToRead,
                        variant = PortalButtonVariant.Text,
                        leadingIcon = Lucide.ArrowLeft,
                    )
                }
            }

            Row(
                modifier = Modifier.fillMaxWidth(),
                verticalAlignment = Alignment.CenterVertically,
                horizontalArrangement = Arrangement.SpaceBetween,
            ) {
                Row(
                    verticalAlignment = Alignment.CenterVertically,
                    horizontalArrangement = Arrangement.spacedBy(AppSpacing.space4),
                ) {
                    Text(
                        text = version?.subtitle().orEmpty(),
                        style = MaterialTheme.typography.bodySmall,
                        color = MaterialTheme.colorScheme.onSurfaceVariant,
                    )
                    if (!controller.isDrafting) {
                        IconButton(
                            onClick = controller::startChangeInfo,
                            modifier = Modifier.size(32.dp),
                        ) {
                            Icon(
                                imageVector = Lucide.Info,
                                contentDescription = stringResource(Res.string.orgchart_version_info),
                                tint = MaterialTheme.colorScheme.onSurfaceVariant,
                                modifier = Modifier.size(18.dp),
                            )
                        }
                    }
                }
                Row(horizontalArrangement = Arrangement.spacedBy(AppSpacing.space8)) {
                    if (controller.isDrafting) {
                        if (canEdit) {
                            AppButton(
                                text = stringResource(Res.string.orgchart_discard_draft),
                                onClick = { controller.showDiscardDialog = true },
                                variant = PortalButtonVariant.Outlined,
                            )
                            AppButton(
                                text = stringResource(Res.string.orgchart_save_draft),
                                onClick = controller::saveDraft,
                                variant = PortalButtonVariant.Filled,
                            )
                        }
                        if (canPublish) {
                            AppButton(
                                text = stringResource(Res.string.orgchart_publish_version),
                                onClick = { controller.showPublishDialog = true },
                                variant = PortalButtonVariant.Accent,
                            )
                        }
                    } else {
                        if (isPdfExportSupported()) {
                            AppButton(
                                text = stringResource(Res.string.orgchart_export),
                                onClick = {
                                    val document =
                                        buildOrgChartPdf(
                                            data = controller.currentData,
                                            version = version,
                                            labels = pdfLabels,
                                            logoPortal = pdfLogoPortalPainter.toPdfImage(widthPx = 316, heightPx = 77),
                                            logoVv = pdfLogoVvPainter.toPdfImage(widthPx = 312, heightPx = 58),
                                        )
                                    val versionName = version?.number?.takeIf { it.isNotBlank() } ?: "atual"
                                    val fileName =
                                        "VV REFEICOES ORGANOGRAMA OPERACIONAL VERSAO $versionName"
                                            .replace(" ", "_")
                                            .replace(Regex("[\\\\/:*?\"<>|]"), "_")
                                    savePdf("$fileName.pdf", encodeBase64(PdfWriter.build(document)))
                                },
                                variant = PortalButtonVariant.Outlined,
                                leadingIcon = Lucide.Download,
                            )
                        }
                        AppButton(
                            text =
                                stringResource(
                                    if (controller.isCurrentVersionSelected) {
                                        Res.string.orgchart_previous_versions
                                    } else {
                                        Res.string.orgchart_other_versions
                                    },
                                ),
                            onClick = { controller.showVersionsDialog = true },
                            variant = PortalButtonVariant.Secondary,
                            leadingIcon = Lucide.History,
                        )
                        if (controller.canCreateVersion && (canEdit || canPublish)) {
                            AppButton(
                                text = stringResource(Res.string.orgchart_new_version),
                                onClick = {
                                    if (controller.hasDraft) {
                                        controller.editDraft()
                                    } else {
                                        controller.startNewVersion()
                                    }
                                },
                                variant = PortalButtonVariant.Filled,
                                leadingIcon = Lucide.Plus,
                            )
                        }
                    }
                }
            }

            if (controller.isDrafting) {
                val changes = controller.changeLog
                if (changes.isNotEmpty()) {
                    ChangeLogPanel(changes)
                }
            }

            AppTextField(
                value = controller.searchQuery,
                onValueChange = { controller.searchQuery = it },
                placeholder = stringResource(Res.string.orgchart_search_placeholder),
                singleLine = true,
                leadingIcon = { Icon(Lucide.Search, contentDescription = null) },
                modifier = Modifier.fillMaxWidth(),
            )

            Row(horizontalArrangement = Arrangement.spacedBy(AppSpacing.space32)) {
                TotalStat(value = "${controller.totals[CompanyType.UPR] ?: 0}", label = stringResource(Res.string.orgchart_total_upr))
                TotalStat(value = "${controller.totals[CompanyType.TRA] ?: 0}", label = stringResource(Res.string.orgchart_total_transported))
                TotalStat(value = "${controller.totals[CompanyType.LOJ] ?: 0}", label = stringResource(Res.string.orgchart_total_stores))
                TotalStat(value = "${controller.totals[CompanyType.EVENTOS] ?: 0}", label = stringResource(Res.string.orgchart_total_events))
            }

            Row(
                modifier = Modifier.fillMaxWidth(),
                verticalAlignment = Alignment.CenterVertically,
                horizontalArrangement = Arrangement.SpaceBetween,
            ) {
                Row(horizontalArrangement = Arrangement.spacedBy(AppSpacing.space16)) {
                    listOf(
                        OrgChartLegend(AppPalette.Warning100, stringResource(Res.string.orgchart_legend_kitchens)),
                        OrgChartLegend(AppPalette.Success100, stringResource(Res.string.orgchart_total_transported)),
                        OrgChartLegend(AppPalette.Error100, stringResource(Res.string.orgchart_total_stores)),
                        OrgChartLegend(AppPalette.Info100, stringResource(Res.string.orgchart_total_events)),
                    ).forEach { item ->
                        LegendItem(color = item.color, label = item.label)
                    }
                }
                if (controller.isDrafting && canEdit) {
                    AddMenuButton(
                        onAddDirector = controller::openAddDirector,
                        onAddManager = { controller.openAddManager() },
                        onAddCompany = { controller.openAddCompany() },
                    )
                }
            }

            if (controller.loading) {
                Box(
                    modifier = Modifier.fillMaxWidth().height(240.dp),
                    contentAlignment = Alignment.Center,
                ) {
                    CircularProgressIndicator()
                }
            } else {
                val orgChart = controller.view
                if (controller.searchQuery.isNotBlank() && orgChart.isEmpty) {
                    EmptyState(message = stringResource(Res.string.orgchart_empty_result))
                } else {
                    Column(
                        modifier = Modifier.fillMaxWidth(),
                        verticalArrangement = Arrangement.spacedBy(AppSpacing.space16),
                    ) {
                        orgChart.directors.forEach { directorView ->
                            DirectorCard(
                                view = directorView,
                                mode = if (canEdit) controller.mode else ScreenMode.Read,
                                drag = drag,
                                onMenuAction = controller::openAction,
                            )
                        }
                        if (orgChart.withoutDirectorManagers.isNotEmpty() ||
                            orgChart.withoutDirectorCompanies.isNotEmpty()
                        ) {
                            WithoutDirectorCard(
                                managers = orgChart.withoutDirectorManagers,
                                orphans = orgChart.withoutDirectorCompanies,
                                mode = if (canEdit) controller.mode else ScreenMode.Read,
                                drag = drag,
                                onMenuAction = controller::openAction,
                            )
                        }
                    }
                }
            }
        }

        controller.toastMessage?.let { message ->
            Box(
                modifier =
                    Modifier
                        .align(Alignment.BottomCenter)
                        .padding(bottom = AppSpacing.space24),
            ) {
                AppToast(message = message, formatArgs = controller.toastArgs)
            }
        }

        drag.draggedCompany?.let { dragged ->
            val localPosition = drag.pointerWindow - contentWindowPosition
            GhostPill(
                text = dragged.name,
                colors = dragged.colors,
                modifier =
                    Modifier.offset {
                        IntOffset(
                            (localPosition.x + 12f).roundToInt(),
                            (localPosition.y + 12f).roundToInt(),
                        )
                    },
            )
        }

        drag.draggedManager?.let { dragged ->
            val localPosition = drag.pointerWindow - contentWindowPosition
            GhostPill(
                text = dragged.name,
                colors = dragged.colors,
                modifier =
                    Modifier.offset {
                        IntOffset(
                            (localPosition.x + 12f).roundToInt(),
                            (localPosition.y + 12f).roundToInt(),
                        )
                    },
            )
        }
    }

    if (controller.showVersionsDialog) {
        val versions = controller.versions
        val labels = versions.map { it.optionLabelText() }
        val versionsByLabel = versions.associateBy { it.optionLabelText() }
        VersionsDialog(
            options = labels,
            selected = controller.selectedVersion?.optionLabelText().orEmpty(),
            onSelect = { label -> versionsByLabel[label]?.id?.let(controller::selectVersion) },
            onDismiss = { controller.showVersionsDialog = false },
        )
    }

    if (controller.showNewVersionDialog) {
        NewVersionDialog(
            version = controller.nextVersion,
            onConfirm = controller::confirmNewVersion,
            onDismiss = controller::dismissNewVersion,
        )
    }

    if (controller.showDiscardDialog) {
        ConfirmDialog(
            title = stringResource(Res.string.orgchart_discard_draft),
            message = stringResource(Res.string.orgchart_discard_draft_msg),
            confirmLabel = stringResource(Res.string.orgchart_discard_action),
            onConfirm = {
                controller.showDiscardDialog = false
                controller.discardDraft()
            },
            onDismiss = { controller.showDiscardDialog = false },
        )
    }

    if (controller.showPublishDialog) {
        val changeMessages = controller.changeLog.map { it.message() }
        ChangesDialog(
            title = stringResource(Res.string.orgchart_publish_version),
            changes = controller.changeLog,
            emptyText = stringResource(Res.string.orgchart_publish_empty),
            supportingText = stringResource(Res.string.orgchart_publish_support),
            confirmLabel = stringResource(Res.string.orgchart_publish_action),
            onConfirm = {
                controller.showPublishDialog = false
                controller.publishDraft(changeMessages)
            },
            onDismiss = { controller.showPublishDialog = false },
        )
    }

    if (controller.showChangeInfoDialog) {
        val previous = controller.previousVersion
        ChangesDialog(
            title = stringResource(Res.string.orgchart_changes_info_title),
            changes = controller.versionChangeLog,
            emptyText =
                if (previous == null) {
                    stringResource(Res.string.orgchart_no_previous)
                } else {
                    stringResource(Res.string.orgchart_no_changes_previous)
                },
            supportingText = previous?.let { stringResource(Res.string.orgchart_comparing, it.number, controller.displayedVersion?.number.orEmpty()) },
            confirmLabel = stringResource(Res.string.orgchart_confirm),
            onDismiss = { controller.showChangeInfoDialog = false },
        )
    }

    if (controller.showPublishSuccess) {
        PublishSuccessDialog(onDismiss = controller::dismissPublishSuccess)
    }

    when (controller.addKind) {
        OrgAddKind.Director ->
            AddDialog(
                title = stringResource(Res.string.orgchart_add_director),
                nameIcon = Lucide.UserRound,
                nameOptions = controller.addDirectorOptions,
                name = controller.addName,
                onNameChange = { controller.addName = it },
                confirmEnabled = controller.isAddConfirmEnabled,
                notFoundText = stringResource(Res.string.orgchart_not_found_director),
                linkLabel = stringResource(Res.string.orgchart_register_director),
                onRegister = {
                    controller.dismissAdd()
                    onNavigate(AdminUsersRoute)
                },
                onConfirm = controller::confirmAdd,
                onDismiss = controller::dismissAdd,
            )
        OrgAddKind.Manager ->
            AddDialog(
                title = stringResource(Res.string.orgchart_add_manager),
                nameIcon = Lucide.Users,
                nameOptions = controller.addManagerOptions,
                name = controller.addName,
                onNameChange = { controller.addName = it },
                confirmEnabled = controller.isAddConfirmEnabled,
                notFoundText = stringResource(Res.string.orgchart_not_found_manager),
                linkLabel = stringResource(Res.string.orgchart_register_manager),
                onRegister = {
                    controller.dismissAdd()
                    onNavigate(AdminUsersRoute)
                },
                onConfirm = controller::confirmAdd,
                onDismiss = controller::dismissAdd,
                extra = {
                    val noDirector = stringResource(Res.string.orgchart_no_director_option)
                    SearchableSelect(
                        leadingIcon = Lucide.UserRound,
                        options = listOf(noDirector) + controller.addManagerDirectorOptions,
                        selected = controller.addManagerDirectorName.ifBlank { noDirector },
                        onSelect = { label -> controller.addManagerDirectorName = if (label == noDirector) "" else label },
                        modifier = Modifier.fillMaxWidth(),
                        underlined = true,
                    )
                },
            )
        OrgAddKind.Company ->
            AddDialog(
                title = stringResource(Res.string.orgchart_add_company),
                nameIcon = Lucide.PackagePlus,
                nameOptions = controller.addCompanyOptions,
                name = controller.addName,
                onNameChange = { controller.addName = it },
                confirmEnabled = controller.isAddConfirmEnabled,
                notFoundText = stringResource(Res.string.orgchart_not_found_company),
                linkLabel = stringResource(Res.string.orgchart_register_company),
                onRegister = {
                    controller.dismissAdd()
                    onNavigate(AdminCompaniesRoute)
                },
                onConfirm = controller::confirmAdd,
                onDismiss = controller::dismissAdd,
                extra = {
                    val placeholder = stringResource(Res.string.orgchart_select_placeholder)
                    val options = controller.responsibleCompanyOptions
                    val labels = options.map { it.labelText() }
                    val optionByLabel = options.associateBy { it.labelText() }
                    SearchableSelect(
                        leadingIcon = Lucide.Users,
                        options = listOf(placeholder) + labels,
                        selected =
                            options
                                .firstOrNull { it.managerId == controller.addCompanyManagerId && it.directorId == controller.addCompanyDirectorId }
                                ?.labelText()
                                ?: placeholder,
                        onSelect = { label -> optionByLabel[label]?.let(controller::selectAddCompanyResponsible) },
                        modifier = Modifier.fillMaxWidth(),
                        underlined = true,
                    )
                },
            )
        null -> Unit
    }

    when (val action = controller.pendingAction) {
        is OrgAction.TransferCompany -> {
            val placeholder = stringResource(Res.string.orgchart_select_placeholder)
            val options = controller.responsibleCompanyOptions
            val labels = options.map { it.labelText() }
            val optionByLabel = options.associateBy { it.labelText() }
            TargetPickerDialog(
                title = stringResource(Res.string.orgchart_transfer_company),
                leadingIcon = Lucide.Users,
                options = listOf(placeholder) + labels,
                selected =
                    options
                        .firstOrNull { it.managerId == controller.targetManagerId && it.directorId == controller.targetDirectorId }
                        ?.labelText()
                        ?: placeholder,
                onSelect = { label -> optionByLabel[label]?.let(controller::selectTargetResponsible) },
                confirmEnabled = controller.isTargetResponsibleSelected,
                onConfirm = controller::confirmAction,
                onDismiss = controller::dismissAction,
            )
        }
        is OrgAction.CopyCompany -> {
            val placeholder = stringResource(Res.string.orgchart_select_placeholder)
            val options = controller.responsibleCompanyOptions
            val labels = options.map { it.labelText() }
            val optionByLabel = options.associateBy { it.labelText() }
            TargetPickerDialog(
                title = stringResource(Res.string.orgchart_copy_company),
                leadingIcon = Lucide.Users,
                options = listOf(placeholder) + labels,
                selected =
                    options
                        .firstOrNull { it.managerId == controller.targetManagerId && it.directorId == controller.targetDirectorId }
                        ?.labelText()
                        ?: placeholder,
                onSelect = { label -> optionByLabel[label]?.let(controller::selectTargetResponsible) },
                confirmEnabled = controller.isTargetResponsibleSelected,
                onConfirm = controller::confirmAction,
                onDismiss = controller::dismissAction,
            )
        }
        is OrgAction.TransferManager ->
            ManagerLinkDialog(
                title = stringResource(Res.string.orgchart_transfer_manager),
                options = controller.allDirectorNames,
                selected = controller.targetName,
                onSelect = { controller.targetName = it },
                companies = controller.pendingManagerCompanies,
                selectedCompanyIds = controller.selectedCompanyIds,
                supportingText = stringResource(Res.string.orgchart_transfer_support),
                onToggleCompany = controller::toggleCompanySelection,
                onToggleAll = controller::toggleAllCompanies,
                onConfirm = controller::confirmAction,
                onDismiss = controller::dismissAction,
            )
        is OrgAction.CopyManager ->
            ManagerLinkDialog(
                title = stringResource(Res.string.orgchart_copy_manager),
                options = controller.allDirectorNames,
                selected = controller.targetName,
                onSelect = { controller.targetName = it },
                companies = controller.pendingManagerCompanies,
                selectedCompanyIds = controller.selectedCompanyIds,
                supportingText = stringResource(Res.string.orgchart_copy_support),
                onToggleCompany = controller::toggleCompanySelection,
                onToggleAll = controller::toggleAllCompanies,
                onConfirm = controller::confirmAction,
                onDismiss = controller::dismissAction,
            )
        is OrgAction.UnlinkCompany ->
            ConfirmDialog(
                title = stringResource(Res.string.orgchart_unlink_company),
                message = stringResource(Res.string.orgchart_unlink_company_msg),
                confirmLabel = stringResource(Res.string.orgchart_unlink_action),
                onConfirm = controller::confirmAction,
                onDismiss = controller::dismissAction,
            )
        is OrgAction.UnlinkCompanyFromDirector ->
            ConfirmDialog(
                title = stringResource(Res.string.orgchart_unlink_director),
                message = stringResource(Res.string.orgchart_unlink_director_msg),
                confirmLabel = stringResource(Res.string.orgchart_unlink_action),
                onConfirm = controller::confirmAction,
                onDismiss = controller::dismissAction,
            )
        is OrgAction.UnlinkManager ->
            ConfirmDialog(
                title = stringResource(Res.string.orgchart_unlink_manager),
                message = stringResource(Res.string.orgchart_unlink_manager_msg),
                confirmLabel = stringResource(Res.string.orgchart_unlink_action),
                onConfirm = controller::confirmAction,
                onDismiss = controller::dismissAction,
                checkboxLabel = stringResource(Res.string.orgchart_move_companies_too),
                checked = controller.includeCompanies,
                onCheckedChange = { controller.includeCompanies = it },
            )
        is OrgAction.DeactivateCompany ->
            ConfirmDialog(
                title = stringResource(Res.string.orgchart_remove_company),
                message = stringResource(Res.string.orgchart_remove_company_msg),
                confirmLabel = stringResource(Res.string.orgchart_remove_company),
                onConfirm = controller::confirmAction,
                onDismiss = controller::dismissAction,
            )
        is OrgAction.DeactivateManager ->
            ConfirmDialog(
                title = stringResource(Res.string.orgchart_remove_manager),
                message = stringResource(Res.string.orgchart_remove_manager_msg),
                confirmLabel = stringResource(Res.string.orgchart_remove_manager),
                onConfirm = controller::confirmAction,
                onDismiss = controller::dismissAction,
            )
        is OrgAction.DeactivateDirector ->
            ConfirmDialog(
                title = stringResource(Res.string.orgchart_remove_director),
                message = stringResource(Res.string.orgchart_remove_director_msg),
                confirmLabel = stringResource(Res.string.orgchart_remove_director),
                onConfirm = controller::confirmAction,
                onDismiss = controller::dismissAction,
            )
        is OrgAction.AddManager, is OrgAction.AddCompany -> Unit
        is OrgAction.ManageSupervisors -> Unit
        null -> Unit
    }

    if (controller.supervisorsCompanyId != null) {
        SupervisorsDialog(controller, canEdit)
    }
}

@Composable
private fun AddMenuButton(
    onAddDirector: () -> Unit,
    onAddManager: () -> Unit,
    onAddCompany: () -> Unit,
) {
    var expanded by remember { mutableStateOf(false) }
    Box {
        AppButton(
            text = stringResource(Res.string.orgchart_add),
            onClick = { expanded = true },
            variant = PortalButtonVariant.Filled,
            leadingIcon = Lucide.Plus,
        )
        DropdownMenu(expanded = expanded, onDismissRequest = { expanded = false }) {
            DropdownMenuItem(
                text = { Text(stringResource(Res.string.orgchart_add_director)) },
                leadingIcon = { Icon(Lucide.UserRound, contentDescription = null) },
                onClick = {
                    expanded = false
                    onAddDirector()
                },
            )
            DropdownMenuItem(
                text = { Text(stringResource(Res.string.orgchart_add_manager)) },
                leadingIcon = { Icon(Lucide.Users, contentDescription = null) },
                onClick = {
                    expanded = false
                    onAddManager()
                },
            )
            DropdownMenuItem(
                text = { Text(stringResource(Res.string.orgchart_add_company)) },
                leadingIcon = { Icon(Lucide.PackagePlus, contentDescription = null) },
                onClick = {
                    expanded = false
                    onAddCompany()
                },
            )
        }
    }
}

@Composable
private fun AddDialog(
    title: String,
    nameIcon: ImageVector,
    nameOptions: List<String>,
    name: String,
    onNameChange: (String) -> Unit,
    confirmEnabled: Boolean,
    notFoundText: String,
    linkLabel: String,
    onRegister: () -> Unit,
    onConfirm: () -> Unit,
    onDismiss: () -> Unit,
    extra: (@Composable () -> Unit)? = null,
) {
    ModalCard(title = title, onDismiss = onDismiss) {
        val placeholder = stringResource(Res.string.orgchart_select_placeholder)
        SearchableSelect(
            leadingIcon = nameIcon,
            options = listOf(placeholder) + nameOptions,
            selected = name.ifBlank { placeholder },
            onSelect = { onNameChange(if (it == placeholder) "" else it) },
            modifier = Modifier.fillMaxWidth(),
            underlined = true,
        )
        extra?.invoke()
        AppButton(
            text = stringResource(Res.string.orgchart_add),
            onClick = onConfirm,
            enabled = confirmEnabled,
            variant = PortalButtonVariant.Filled,
            modifier = Modifier.fillMaxWidth(),
        )
        Column(
            modifier = Modifier.fillMaxWidth(),
            horizontalAlignment = Alignment.CenterHorizontally,
            verticalArrangement = Arrangement.spacedBy(AppSpacing.space8),
        ) {
            Text(
                text = notFoundText,
                style = MaterialTheme.typography.bodySmall,
                color = MaterialTheme.colorScheme.onSurfaceVariant,
            )
            AppButton(
                text = linkLabel,
                onClick = onRegister,
                variant = PortalButtonVariant.Text,
            )
        }
    }
}

@Composable
private fun ModalCard(
    title: String,
    onDismiss: () -> Unit,
    content: @Composable ColumnScope.() -> Unit,
) {
    Dialog(onDismissRequest = onDismiss) {
        BoxWithConstraints {
            val scrollState = rememberScrollState()
            Surface(
                modifier = Modifier.heightIn(max = maxHeight * 0.9f),
                shape = AppShapes.large,
                color = Color.White,
            ) {
                Box {
                    Column(
                        modifier =
                            Modifier
                                .verticalScroll(scrollState)
                                .padding(AppSpacing.space24),
                        verticalArrangement = Arrangement.spacedBy(AppSpacing.space16),
                    ) {
                        Text(
                            text = title,
                            style = MaterialTheme.typography.titleLarge,
                            modifier = Modifier.padding(end = AppSpacing.space32),
                        )
                        content()
                    }
                    AppScrollbar(
                        state = scrollState,
                        modifier =
                            Modifier
                                .align(Alignment.CenterEnd)
                                .fillMaxHeight()
                                .padding(vertical = AppSpacing.space8),
                    )
                    IconButton(
                        onClick = onDismiss,
                        modifier =
                            Modifier
                                .align(Alignment.TopEnd)
                                .padding(AppSpacing.space8),
                    ) {
                        Icon(
                            imageVector = Lucide.X,
                            contentDescription = stringResource(Res.string.orgchart_close),
                            tint = MaterialTheme.colorScheme.onSurfaceVariant,
                        )
                    }
                }
            }
        }
    }
}

@Composable
private fun VersionsDialog(
    options: List<String>,
    selected: String,
    onSelect: (String) -> Unit,
    onDismiss: () -> Unit,
) {
    ModalCard(title = stringResource(Res.string.orgchart_versions_title), onDismiss = onDismiss) {
        SearchableSelect(
            leadingIcon = Lucide.History,
            options = options,
            selected = selected,
            onSelect = onSelect,
            modifier = Modifier.fillMaxWidth(),
            underlined = true,
        )
    }
}

@Composable
private fun NewVersionDialog(
    version: String,
    onConfirm: () -> Unit,
    onDismiss: () -> Unit,
) {
    ModalCard(title = stringResource(Res.string.orgchart_new_version), onDismiss = onDismiss) {
        Text(
            text = stringResource(Res.string.orgchart_new_version_body),
            style = MaterialTheme.typography.bodyMedium,
            color = MaterialTheme.colorScheme.onSurfaceVariant,
        )
        Text(
            text = version,
            style = MaterialTheme.typography.headlineSmall,
        )
        Row(
            modifier = Modifier.fillMaxWidth(),
            horizontalArrangement = Arrangement.spacedBy(AppSpacing.space8, Alignment.End),
        ) {
            AppButton(
                text = stringResource(Res.string.orgchart_cancel),
                onClick = onDismiss,
                variant = PortalButtonVariant.Text,
            )
            AppButton(
                text = stringResource(Res.string.orgchart_create_version),
                onClick = onConfirm,
                variant = PortalButtonVariant.Filled,
            )
        }
    }
}

@Composable
private fun SupervisorsDialog(
    controller: OrgChartController,
    canEdit: Boolean,
) {
    val companyId = controller.supervisorsCompanyId ?: return
    val editable = canEdit && (controller.isDrafting || controller.isCurrentVersionSelected)
    var editMode by remember(companyId) { mutableStateOf(false) }
    val unitName =
        controller.currentData.companies
            .firstOrNull { it.id == companyId }
            ?.name
            .orEmpty()

    ModalCard(title = stringResource(Res.string.orgchart_manage_supervisors), onDismiss = controller::dismissSupervisors) {
        Row(verticalAlignment = Alignment.CenterVertically, horizontalArrangement = Arrangement.spacedBy(AppSpacing.space8)) {
            Icon(
                imageVector = Lucide.Building,
                contentDescription = null,
                tint = MaterialTheme.colorScheme.onSurfaceVariant,
                modifier = Modifier.size(18.dp),
            )
            Text(
                text = unitName,
                style = MaterialTheme.typography.bodySmall,
                color = MaterialTheme.colorScheme.onSurfaceVariant,
            )
        }
        if (editMode) {
            // Garante que supervisores já vinculados (mesmo que não sejam mais candidatos) apareçam
            // como tags removíveis — senão continuariam vinculados no salvamento.
            val assigned = controller.supervisorsOf(companyId)
            val options =
                (
                    controller.supervisorCandidates.map { SelectOption(it.id, it.name) } +
                        assigned.map { SelectOption(it.id, it.name) }
                ).distinctBy { it.id }
            MultiSelectField(
                options = options,
                selectedIds = controller.currentData.unitSupervisors[companyId].orEmpty(),
                onToggle = { controller.toggleSupervisor(companyId, it) },
                searchPlaceholder = stringResource(Res.string.orgchart_supervisor_search),
                emptyLabel = stringResource(Res.string.orgchart_supervisor_empty),
            )
            Row(
                modifier = Modifier.fillMaxWidth(),
                horizontalArrangement = Arrangement.spacedBy(AppSpacing.space8, Alignment.End),
            ) {
                AppButton(
                    text = stringResource(Res.string.orgchart_cancel),
                    onClick = {
                        controller.cancelSupervisors()
                        editMode = false
                    },
                    variant = PortalButtonVariant.Text,
                )
                AppButton(
                    text = stringResource(Res.string.orgchart_save),
                    onClick = {
                        controller.saveSupervisors(companyId)
                        editMode = false
                    },
                    variant = PortalButtonVariant.Filled,
                )
            }
        } else {
            val selected = controller.supervisorsOf(companyId)
            if (selected.isEmpty()) {
                Text(
                    text = stringResource(Res.string.orgchart_supervisor_none),
                    style = MaterialTheme.typography.bodyMedium,
                    color = MaterialTheme.colorScheme.onSurfaceVariant,
                )
            } else {
                Column(verticalArrangement = Arrangement.spacedBy(AppSpacing.space8)) {
                    Row(modifier = Modifier.fillMaxWidth()) {
                        Text(
                            text = stringResource(Res.string.orgchart_supervisor_col_name),
                            style = MaterialTheme.typography.labelMedium,
                            color = MaterialTheme.colorScheme.onSurfaceVariant,
                            modifier = Modifier.weight(1f),
                        )
                        Text(
                            text = stringResource(Res.string.orgchart_supervisor_col_role),
                            style = MaterialTheme.typography.labelMedium,
                            color = MaterialTheme.colorScheme.onSurfaceVariant,
                            modifier = Modifier.weight(1f),
                        )
                    }
                    HorizontalDivider(color = MaterialTheme.colorScheme.outlineVariant)
                    selected.forEach { supervisor ->
                        Row(modifier = Modifier.fillMaxWidth()) {
                            Text(supervisor.name, style = MaterialTheme.typography.bodyMedium, modifier = Modifier.weight(1f))
                            Text(
                                text = supervisor.cargo.ifBlank { "—" },
                                style = MaterialTheme.typography.bodyMedium,
                                color = MaterialTheme.colorScheme.onSurfaceVariant,
                                modifier = Modifier.weight(1f),
                            )
                        }
                    }
                }
            }
            if (editable) {
                Row(
                    modifier = Modifier.fillMaxWidth(),
                    horizontalArrangement = Arrangement.spacedBy(AppSpacing.space8, Alignment.End),
                ) {
                    AppButton(
                        text = stringResource(Res.string.orgchart_supervisor_edit),
                        onClick = { editMode = true },
                        variant = PortalButtonVariant.Filled,
                        leadingIcon = Lucide.Pencil,
                    )
                }
            }
        }
    }
}

@Composable
private fun ConfirmDialog(
    title: String,
    message: String,
    confirmLabel: String,
    onConfirm: () -> Unit,
    onDismiss: () -> Unit,
    checkboxLabel: String? = null,
    checked: Boolean = false,
    onCheckedChange: (Boolean) -> Unit = {},
) {
    ModalCard(title = title, onDismiss = onDismiss) {
        Text(
            text = message,
            style = MaterialTheme.typography.bodyMedium,
            color = MaterialTheme.colorScheme.onSurfaceVariant,
        )
        if (checkboxLabel != null) {
            Row(
                verticalAlignment = Alignment.CenterVertically,
                horizontalArrangement = Arrangement.spacedBy(AppSpacing.space8),
            ) {
                Checkbox(checked = checked, onCheckedChange = onCheckedChange)
                Text(
                    text = checkboxLabel,
                    style = MaterialTheme.typography.bodyMedium,
                )
            }
        }
        Row(
            modifier = Modifier.fillMaxWidth(),
            horizontalArrangement = Arrangement.spacedBy(AppSpacing.space8, Alignment.End),
        ) {
            AppButton(
                text = stringResource(Res.string.orgchart_cancel),
                onClick = onDismiss,
                variant = PortalButtonVariant.Text,
            )
            AppButton(
                text = confirmLabel,
                onClick = onConfirm,
                variant = PortalButtonVariant.Filled,
            )
        }
    }
}

@Composable
private fun TargetPickerDialog(
    title: String,
    leadingIcon: ImageVector,
    options: List<String>,
    selected: String,
    onSelect: (String) -> Unit,
    confirmEnabled: Boolean,
    onConfirm: () -> Unit,
    onDismiss: () -> Unit,
) {
    ModalCard(title = title, onDismiss = onDismiss) {
        SearchableSelect(
            leadingIcon = leadingIcon,
            options = options,
            selected = selected,
            onSelect = onSelect,
            modifier = Modifier.fillMaxWidth(),
            underlined = true,
        )
        Row(
            modifier = Modifier.fillMaxWidth(),
            horizontalArrangement = Arrangement.spacedBy(AppSpacing.space8, Alignment.End),
        ) {
            AppButton(
                text = stringResource(Res.string.orgchart_cancel),
                onClick = onDismiss,
                variant = PortalButtonVariant.Text,
            )
            AppButton(
                text = stringResource(Res.string.orgchart_confirm),
                onClick = onConfirm,
                enabled = confirmEnabled,
                variant = PortalButtonVariant.Filled,
            )
        }
    }
}

@Composable
private fun ManagerLinkDialog(
    title: String,
    options: List<String>,
    selected: String,
    onSelect: (String) -> Unit,
    companies: List<Company>,
    selectedCompanyIds: Set<String>,
    supportingText: String,
    onToggleCompany: (String) -> Unit,
    onToggleAll: (Boolean) -> Unit,
    onConfirm: () -> Unit,
    onDismiss: () -> Unit,
) {
    ModalCard(title = title, onDismiss = onDismiss) {
        SearchableSelect(
            leadingIcon = Lucide.UserRound,
            options = options,
            selected = selected,
            onSelect = onSelect,
            modifier = Modifier.fillMaxWidth(),
            underlined = true,
        )
        Text(
            text = supportingText,
            style = MaterialTheme.typography.bodyMedium,
            color = MaterialTheme.colorScheme.onSurfaceVariant,
        )
        if (companies.isEmpty()) {
            Text(
                text = stringResource(Res.string.orgchart_no_companies),
                style = MaterialTheme.typography.bodyMedium,
                color = MaterialTheme.colorScheme.onSurfaceVariant,
            )
        } else {
            Row(
                verticalAlignment = Alignment.CenterVertically,
                horizontalArrangement = Arrangement.spacedBy(AppSpacing.space8),
            ) {
                Checkbox(
                    checked = selectedCompanyIds.size == companies.size,
                    onCheckedChange = onToggleAll,
                )
                Text(
                    text = stringResource(Res.string.orgchart_mark_all_companies),
                    style = MaterialTheme.typography.bodyMedium,
                )
            }
            companies.forEach { company ->
                Row(
                    verticalAlignment = Alignment.CenterVertically,
                    horizontalArrangement = Arrangement.spacedBy(AppSpacing.space8),
                ) {
                    Checkbox(
                        checked = company.id in selectedCompanyIds,
                        onCheckedChange = { onToggleCompany(company.id) },
                    )
                    Text(
                        text = company.name,
                        style = MaterialTheme.typography.bodyMedium,
                    )
                }
            }
        }
        Row(
            modifier = Modifier.fillMaxWidth(),
            horizontalArrangement = Arrangement.spacedBy(AppSpacing.space8, Alignment.End),
        ) {
            AppButton(
                text = stringResource(Res.string.orgchart_cancel),
                onClick = onDismiss,
                variant = PortalButtonVariant.Text,
            )
            AppButton(
                text = stringResource(Res.string.orgchart_confirm),
                onClick = onConfirm,
                enabled = selected.isNotBlank(),
                variant = PortalButtonVariant.Filled,
            )
        }
    }
}

@Composable
private fun PublishSuccessDialog(onDismiss: () -> Unit) {
    SuccessDialog(
        title = stringResource(Res.string.orgchart_publish_success),
        onDismiss = onDismiss,
    )
}

@Composable
private fun GhostPill(
    text: String,
    colors: PillColors,
    modifier: Modifier = Modifier,
) {
    Surface(
        modifier = modifier.alpha(0.9f),
        shape = RoundedCornerShape(percent = 50),
        color = colors.container,
        contentColor = colors.content,
        border = colors.border?.let { BorderStroke(1.dp, it) },
        shadowElevation = 8.dp,
    ) {
        Box(
            modifier = Modifier.padding(horizontal = AppSpacing.space16, vertical = AppSpacing.space8),
            contentAlignment = Alignment.Center,
        ) {
            Text(
                text = text,
                style = MaterialTheme.typography.bodyMedium,
                textAlign = TextAlign.Center,
                maxLines = 3,
                overflow = TextOverflow.Ellipsis,
            )
        }
    }
}

@Composable
private fun DirectorCard(
    view: DirectorView,
    mode: ScreenMode,
    drag: OrgDragController,
    onMenuAction: (OrgAction) -> Unit,
) {
    val director = view.director
    val managers = view.managers
    val directCompanies = view.directCompanies
    val counts = view.counts
    val interactionSource = remember { MutableInteractionSource() }
    val hovered by interactionSource.collectIsHoveredAsState()
    var menuExpanded by remember { mutableStateOf(false) }
    val isDropTarget = drag.isOverDirector(director.id)

    DisposableEffect(director.id) {
        onDispose { drag.unregisterDirectorBounds(director.id) }
    }

    Surface(
        modifier =
            Modifier
                .fillMaxWidth()
                .onGloballyPositioned { drag.registerDirectorBounds(director.id, it.boundsInWindow()) },
        shape = AppShapes.large,
        color = MaterialTheme.colorScheme.surface,
        border =
            BorderStroke(
                if (isDropTarget) 2.dp else 1.dp,
                if (isDropTarget) MaterialTheme.colorScheme.primary else MaterialTheme.colorScheme.outlineVariant,
            ),
    ) {
        Column {
            Row(
                modifier =
                    Modifier
                        .fillMaxWidth()
                        .hoverable(interactionSource)
                        .padding(AppSpacing.space16),
                verticalAlignment = Alignment.CenterVertically,
            ) {
                Row(
                    modifier = Modifier.weight(1f),
                    verticalAlignment = Alignment.CenterVertically,
                    horizontalArrangement = Arrangement.spacedBy(AppSpacing.space12),
                ) {
                    Icon(
                        imageVector = Lucide.UserRound,
                        contentDescription = null,
                        tint = MaterialTheme.colorScheme.primary,
                    )
                    Column {
                        Text(
                            text = director.name,
                            style = MaterialTheme.typography.titleMedium,
                        )
                        Text(
                            text = stringResource(Res.string.orgchart_director_subtitle),
                            style = MaterialTheme.typography.bodySmall,
                            color = MaterialTheme.colorScheme.onSurfaceVariant,
                        )
                    }
                    if ((hovered || menuExpanded) && mode != ScreenMode.Read) {
                        Box {
                            IconButton(
                                onClick = { menuExpanded = true },
                                modifier = Modifier.size(24.dp),
                            ) {
                                Icon(
                                    imageVector = Lucide.EllipsisVertical,
                                    contentDescription = stringResource(Res.string.orgchart_director_actions),
                                    tint = MaterialTheme.colorScheme.onSurfaceVariant,
                                )
                            }
                            DropdownMenu(
                                expanded = menuExpanded,
                                onDismissRequest = { menuExpanded = false },
                            ) {
                                DropdownMenuItem(
                                    text = { Text(stringResource(Res.string.orgchart_add_manager)) },
                                    leadingIcon = { Icon(Lucide.UserPlus, contentDescription = null) },
                                    onClick = {
                                        menuExpanded = false
                                        onMenuAction(OrgAction.AddManager(director.id))
                                    },
                                )
                                DropdownMenuItem(
                                    text = { Text(stringResource(Res.string.orgchart_add_company)) },
                                    leadingIcon = { Icon(Lucide.PackagePlus, contentDescription = null) },
                                    onClick = {
                                        menuExpanded = false
                                        onMenuAction(OrgAction.AddCompany(null, director.id))
                                    },
                                )
                                DropdownMenuItem(
                                    text = { Text(stringResource(Res.string.orgchart_remove_director)) },
                                    leadingIcon = { Icon(Lucide.CircleOff, contentDescription = null) },
                                    onClick = {
                                        menuExpanded = false
                                        onMenuAction(OrgAction.DeactivateDirector(director.id))
                                    },
                                )
                            }
                        }
                    }
                }
                DirectorTotalsTable(counts)
            }
            HorizontalDivider(color = MaterialTheme.colorScheme.outlineVariant)
            Column(
                modifier =
                    Modifier
                        .fillMaxWidth()
                        .padding(AppSpacing.space16),
                verticalArrangement = Arrangement.spacedBy(AppSpacing.space16),
            ) {
                Box(
                    modifier = Modifier.fillMaxWidth(),
                    contentAlignment = Alignment.Center,
                ) {
                    Row(
                        modifier = Modifier.horizontalScroll(rememberScrollState()),
                        horizontalArrangement = Arrangement.spacedBy(AppSpacing.space24),
                    ) {
                        ManagerColumns(
                            managers = managers,
                            mode = mode,
                            directorId = director.id,
                            managerColors =
                                PillColors(
                                    container = MaterialTheme.colorScheme.surfaceVariant,
                                    content = MaterialTheme.colorScheme.onSurface,
                                    border = null,
                                ),
                            drag = drag,
                            onMenuAction = onMenuAction,
                        )
                    }
                }
                if (directCompanies.isNotEmpty()) {
                    UnassignedSection(
                        companies = directCompanies,
                        directorId = director.id,
                        mode = mode,
                        drag = drag,
                        onMenuAction = onMenuAction,
                    )
                }
            }
        }
    }
}

@Composable
private fun DirectorTotalsTable(counts: Map<CompanyType, Int>) {
    val columns =
        listOf(
            stringResource(Res.string.orgchart_cell_upr) to (counts[CompanyType.UPR] ?: 0),
            stringResource(Res.string.orgchart_cell_tra) to (counts[CompanyType.TRA] ?: 0),
            stringResource(Res.string.orgchart_cell_loj) to (counts[CompanyType.LOJ] ?: 0),
            stringResource(Res.string.orgchart_cell_evt) to (counts[CompanyType.EVENTOS] ?: 0),
        ).filter { it.second > 0 }

    Row(verticalAlignment = Alignment.CenterVertically) {
        columns.forEachIndexed { index, (label, value) ->
            if (index > 0) {
                TotalsDivider()
            }
            TotalCell(label = label, value = value)
        }
    }
}

@Composable
private fun TotalCell(
    label: String,
    value: Int,
) {
    Column(
        horizontalAlignment = Alignment.CenterHorizontally,
        verticalArrangement = Arrangement.spacedBy(AppSpacing.space4),
    ) {
        Text(
            text = label,
            style = MaterialTheme.typography.labelSmall,
            color = MaterialTheme.colorScheme.onSurfaceVariant,
        )
        Text(
            text = "$value",
            style = MaterialTheme.typography.titleMedium,
            color = MaterialTheme.colorScheme.onSurface,
        )
    }
}

@Composable
private fun TotalsDivider() {
    Box(
        modifier =
            Modifier
                .padding(horizontal = AppSpacing.space8)
                .width(1.dp)
                .height(32.dp)
                .background(MaterialTheme.colorScheme.outlineVariant),
    )
}

@Composable
private fun ManagerColumn(
    manager: Manager,
    companies: List<Company>,
    mode: ScreenMode,
    managerColors: PillColors,
    directorId: String,
    drag: OrgDragController,
    onMenuAction: (OrgAction) -> Unit,
) {
    val isDropTarget = drag.isOver(directorId, manager.id)

    DisposableEffect(directorId, manager.id) {
        onDispose { drag.unregisterManagerBounds(directorId, manager.id) }
    }

    Column(
        modifier =
            Modifier
                .onGloballyPositioned { coords ->
                    drag.registerManagerBounds(directorId, manager.id, coords.boundsInWindow())
                }.then(
                    if (isDropTarget) {
                        Modifier.background(
                            MaterialTheme.colorScheme.primaryContainer.copy(alpha = 0.4f),
                            AppShapes.medium,
                        )
                    } else {
                        Modifier
                    },
                ).padding(AppSpacing.space8),
        horizontalAlignment = Alignment.CenterHorizontally,
    ) {
        OrgPill(
            text = manager.name,
            colors = managerColors,
            mode = mode,
            drag = drag,
            directorId = directorId,
            managerId = manager.id,
            companyId = null,
            emphasized = true,
            onMenuAction = onMenuAction,
        )
        Connector()
        companies.forEachIndexed { index, company ->
            OrgPill(
                text = company.name,
                colors = company.type.pillColors(),
                mode = mode,
                drag = drag,
                directorId = directorId,
                managerId = manager.id,
                companyId = company.id,
                onMenuAction = onMenuAction,
            )
            if (index < companies.lastIndex) {
                Connector()
            }
        }
    }
}

private data class ManagerGroup(
    val managers: List<ManagerView>,
    val companies: List<Company>,
)

private fun groupManagerViews(managers: List<ManagerView>): List<ManagerGroup> =
    groupByCompanySet(managers) { it.companies }.map { group ->
        ManagerGroup(group, group.first().companies)
    }

@Composable
private fun ManagerColumns(
    managers: List<ManagerView>,
    mode: ScreenMode,
    directorId: String,
    managerColors: PillColors,
    drag: OrgDragController,
    onMenuAction: (OrgAction) -> Unit,
) {
    if (mode == ScreenMode.Read) {
        groupManagerViews(managers).forEach { group ->
            if (group.managers.size > 1) {
                SharedManagerColumn(group, mode, directorId, managerColors, drag, onMenuAction)
            } else {
                val managerView = group.managers.first()
                ManagerColumn(
                    manager = managerView.manager,
                    companies = group.companies,
                    mode = mode,
                    managerColors = managerColors,
                    directorId = directorId,
                    drag = drag,
                    onMenuAction = onMenuAction,
                )
            }
        }
    } else {
        managers.forEach { managerView ->
            ManagerColumn(
                manager = managerView.manager,
                companies = managerView.companies,
                mode = mode,
                managerColors = managerColors,
                directorId = directorId,
                drag = drag,
                onMenuAction = onMenuAction,
            )
        }
    }
}

@Composable
private fun SharedManagerColumn(
    group: ManagerGroup,
    mode: ScreenMode,
    directorId: String,
    managerColors: PillColors,
    drag: OrgDragController,
    onMenuAction: (OrgAction) -> Unit,
) {
    Column(
        modifier = Modifier.padding(AppSpacing.space8),
        horizontalAlignment = Alignment.CenterHorizontally,
    ) {
        Row(
            modifier = Modifier.height(IntrinsicSize.Max),
            horizontalArrangement = Arrangement.spacedBy(AppSpacing.space8),
        ) {
            group.managers.forEach { managerView ->
                OrgPill(
                    text = managerView.manager.name,
                    colors = managerColors,
                    mode = mode,
                    drag = drag,
                    directorId = directorId,
                    managerId = managerView.manager.id,
                    companyId = null,
                    emphasized = true,
                    modifier = Modifier.fillMaxHeight(),
                    onMenuAction = onMenuAction,
                )
            }
        }
        SharedConnector(group.managers.size)
        val firstManager = group.managers.first()
        val sharedManagerId = firstManager.manager.id
        group.companies.forEachIndexed { index, company ->
            OrgPill(
                text = company.name,
                colors = company.type.pillColors(),
                mode = mode,
                drag = drag,
                directorId = directorId,
                managerId = sharedManagerId,
                companyId = company.id,
                onMenuAction = onMenuAction,
            )
            if (index < group.companies.lastIndex) {
                Connector()
            }
        }
    }
}

@Composable
private fun SharedConnector(managerCount: Int) {
    val lineColor = MaterialTheme.colorScheme.outlineVariant
    Canvas(
        modifier =
            Modifier
                .width(PillWidth * managerCount + AppSpacing.space8 * (managerCount - 1))
                .height(AppSpacing.space12),
    ) {
        val pillWidth = PillWidth.toPx()
        val gap = AppSpacing.space8.toPx()
        val centers = (0 until managerCount).map { index -> index * (pillWidth + gap) + pillWidth / 2f }
        val busY = size.height / 2f
        val stroke = 2.dp.toPx()
        drawLine(lineColor, Offset(centers.first(), busY), Offset(centers.last(), busY), strokeWidth = stroke)
        centers.forEach { center ->
            drawLine(lineColor, Offset(center, 0f), Offset(center, busY), strokeWidth = stroke)
        }
        drawLine(lineColor, Offset(size.width / 2f, busY), Offset(size.width / 2f, size.height), strokeWidth = stroke)
    }
}

@Composable
private fun Connector() {
    Box(
        modifier =
            Modifier
                .width(2.dp)
                .height(AppSpacing.space12)
                .background(MaterialTheme.colorScheme.outlineVariant),
    )
}

@OptIn(ExperimentalLayoutApi::class)
@Composable
private fun UnassignedSection(
    companies: List<Company>,
    directorId: String,
    mode: ScreenMode,
    drag: OrgDragController,
    onMenuAction: (OrgAction) -> Unit,
) {
    Column(
        modifier = Modifier.fillMaxWidth(),
        horizontalAlignment = Alignment.CenterHorizontally,
        verticalArrangement = Arrangement.spacedBy(AppSpacing.space8),
    ) {
        Text(
            text = stringResource(Res.string.orgchart_unassigned_manager),
            style = MaterialTheme.typography.labelLarge,
            color = MaterialTheme.colorScheme.onSurfaceVariant,
        )
        FlowRow(
            modifier = Modifier.fillMaxWidth(),
            horizontalArrangement = Arrangement.spacedBy(AppSpacing.space8, Alignment.CenterHorizontally),
            verticalArrangement = Arrangement.spacedBy(AppSpacing.space8),
        ) {
            companies.forEach { company ->
                OrgPill(
                    text = company.name,
                    colors = company.type.pillColors(),
                    mode = mode,
                    drag = drag,
                    directorId = directorId,
                    managerId = null,
                    companyId = company.id,
                    onMenuAction = onMenuAction,
                )
            }
        }
    }
}

@Composable
private fun WithoutDirectorCard(
    managers: List<ManagerView>,
    orphans: List<Company>,
    mode: ScreenMode,
    drag: OrgDragController,
    onMenuAction: (OrgAction) -> Unit,
) {
    val counts = (managers.flatMap { it.companies } + orphans).distinctBy { it.id }.groupingBy { it.type }.eachCount()
    val isDropTarget = drag.isOverDirector("")

    DisposableEffect(Unit) {
        onDispose { drag.unregisterDirectorBounds("") }
    }

    Surface(
        modifier =
            Modifier
                .fillMaxWidth()
                .onGloballyPositioned { drag.registerDirectorBounds("", it.boundsInWindow()) },
        shape = AppShapes.large,
        color = MaterialTheme.colorScheme.surface,
        border =
            BorderStroke(
                if (isDropTarget) 2.dp else 1.dp,
                if (isDropTarget) MaterialTheme.colorScheme.primary else MaterialTheme.colorScheme.outlineVariant,
            ),
    ) {
        Column {
            Row(
                modifier =
                    Modifier
                        .fillMaxWidth()
                        .padding(AppSpacing.space16),
                verticalAlignment = Alignment.CenterVertically,
            ) {
                Text(
                    text = stringResource(Res.string.orgchart_without_director),
                    style = MaterialTheme.typography.titleMedium,
                    modifier = Modifier.weight(1f),
                )
                DirectorTotalsTable(counts)
            }
            HorizontalDivider(color = MaterialTheme.colorScheme.outlineVariant)
            Column(
                modifier =
                    Modifier
                        .fillMaxWidth()
                        .padding(AppSpacing.space16),
                verticalArrangement = Arrangement.spacedBy(AppSpacing.space16),
            ) {
                Box(
                    modifier = Modifier.fillMaxWidth(),
                    contentAlignment = Alignment.Center,
                ) {
                    Row(
                        modifier = Modifier.horizontalScroll(rememberScrollState()),
                        horizontalArrangement = Arrangement.spacedBy(AppSpacing.space24),
                    ) {
                        ManagerColumns(
                            managers = managers,
                            mode = mode,
                            directorId = "",
                            managerColors =
                                PillColors(
                                    container = MaterialTheme.colorScheme.primary,
                                    content = MaterialTheme.colorScheme.onPrimary,
                                    border = null,
                                ),
                            drag = drag,
                            onMenuAction = onMenuAction,
                        )
                    }
                }
                if (orphans.isNotEmpty()) {
                    UnassignedSection(
                        companies = orphans,
                        directorId = "",
                        mode = mode,
                        drag = drag,
                        onMenuAction = onMenuAction,
                    )
                }
            }
        }
    }
}

private data class PillColors(
    val container: Color,
    val content: Color,
    val border: Color?,
)

private fun CompanyType.pillColors(): PillColors =
    when (this) {
        CompanyType.UPR ->
            PillColors(
                container = AppPalette.Warning100,
                content = AppPalette.Warning900,
                border = AppPalette.Warning500,
            )
        CompanyType.TRA ->
            PillColors(
                container = AppPalette.Success100,
                content = AppPalette.Success900,
                border = AppPalette.Success500,
            )
        CompanyType.LOJ ->
            PillColors(
                container = AppPalette.Error100,
                content = AppPalette.Error900,
                border = AppPalette.Error500,
            )
        CompanyType.EVENTOS ->
            PillColors(
                container = AppPalette.Info100,
                content = AppPalette.Info900,
                border = AppPalette.Info500,
            )
    }

@Composable
private fun OrgPill(
    text: String,
    colors: PillColors,
    mode: ScreenMode,
    drag: OrgDragController,
    directorId: String,
    managerId: String?,
    companyId: String?,
    emphasized: Boolean = false,
    modifier: Modifier = Modifier,
    onMenuAction: (OrgAction) -> Unit,
) {
    val interactionSource = remember { MutableInteractionSource() }
    val hovered by interactionSource.collectIsHoveredAsState()
    var menuExpanded by remember { mutableStateOf(false) }
    val pillShape = RoundedCornerShape(percent = 50)
    var pillWindowPosition by remember { mutableStateOf(Offset.Zero) }
    val currentPillWindowPosition by rememberUpdatedState(pillWindowPosition)
    val dragSource =
        if (companyId != null) {
            DraggedCompany(directorId, managerId, companyId, text, colors)
        } else {
            null
        }
    val managerDragSource =
        if (companyId == null && managerId != null) {
            DraggedManager(directorId, managerId, text, colors)
        } else {
            null
        }

    val currentDragSource by rememberUpdatedState(dragSource)
    val currentManagerDragSource by rememberUpdatedState(managerDragSource)

    val dragModifier =
        if (dragSource != null && mode != ScreenMode.Read) {
            Modifier.pointerInput(dragSource.companyId) {
                detectDragGestures(
                    onDragStart = { offset ->
                        currentDragSource?.let { source ->
                            drag.startCompanyDrag(
                                directorId = source.directorId,
                                managerId = source.managerId,
                                companyId = source.companyId,
                                name = source.name,
                                colors = source.colors,
                                position = currentPillWindowPosition + offset,
                            )
                        }
                    },
                    onDragEnd = { drag.endDrag() },
                    onDragCancel = { drag.cancelDrag() },
                ) { change, _ ->
                    change.consume()
                    drag.updateDrag(currentPillWindowPosition + change.position)
                }
            }
        } else if (managerDragSource != null && mode != ScreenMode.Read) {
            Modifier.pointerInput(managerDragSource.managerId) {
                detectDragGestures(
                    onDragStart = { offset ->
                        currentManagerDragSource?.let { source ->
                            drag.startManagerDrag(
                                directorId = source.directorId,
                                managerId = source.managerId,
                                name = source.name,
                                colors = source.colors,
                                position = currentPillWindowPosition + offset,
                            )
                        }
                    },
                    onDragEnd = { drag.endDrag() },
                    onDragCancel = { drag.cancelDrag() },
                ) { change, _ ->
                    change.consume()
                    drag.updateDrag(currentPillWindowPosition + change.position)
                }
            }
        } else {
            Modifier
        }

    val menuItems: List<Pair<OrgMenuOption, OrgAction>> =
        if (mode == ScreenMode.Read) {
            if (companyId != null) {
                listOf(
                    OrgMenuOption(stringResource(Res.string.orgchart_manage_supervisors), Lucide.UserRoundCog) to
                        OrgAction.ManageSupervisors(companyId),
                )
            } else {
                emptyList()
            }
        } else if (companyId == null) {
            val currentManagerId = requireNotNull(managerId)
            if (directorId.isEmpty()) {
                listOf(
                    OrgMenuOption(stringResource(Res.string.orgchart_set_director), Lucide.ArrowRightLeft) to
                        OrgAction.TransferManager(directorId, currentManagerId),
                    OrgMenuOption(stringResource(Res.string.orgchart_add_company), Lucide.PackagePlus) to
                        OrgAction.AddCompany(currentManagerId, directorId),
                    OrgMenuOption(stringResource(Res.string.orgchart_remove_manager), Lucide.CircleOff) to
                        OrgAction.DeactivateManager(directorId, currentManagerId),
                )
            } else {
                listOf(
                    OrgMenuOption(stringResource(Res.string.orgchart_transfer_to_director), Lucide.ArrowRightLeft) to
                        OrgAction.TransferManager(directorId, currentManagerId),
                    OrgMenuOption(stringResource(Res.string.orgchart_copy_to_director), Lucide.Copy) to
                        OrgAction.CopyManager(directorId, currentManagerId),
                    OrgMenuOption(stringResource(Res.string.orgchart_unlink_manager), Lucide.Unlink) to
                        OrgAction.UnlinkManager(directorId, currentManagerId),
                    OrgMenuOption(stringResource(Res.string.orgchart_add_company), Lucide.PackagePlus) to
                        OrgAction.AddCompany(currentManagerId, directorId),
                    OrgMenuOption(stringResource(Res.string.orgchart_remove_manager), Lucide.CircleOff) to
                        OrgAction.DeactivateManager(directorId, currentManagerId),
                )
            }
        } else if (managerId != null) {
            listOf(
                OrgMenuOption(stringResource(Res.string.orgchart_transfer_to), Lucide.ArrowRightLeft) to
                    OrgAction.TransferCompany(directorId, managerId, companyId),
                OrgMenuOption(stringResource(Res.string.orgchart_copy_to), Lucide.Copy) to
                    OrgAction.CopyCompany(directorId, managerId, companyId),
                OrgMenuOption(stringResource(Res.string.orgchart_unlink_company), Lucide.Unlink) to
                    OrgAction.UnlinkCompany(directorId, managerId, companyId),
                OrgMenuOption(stringResource(Res.string.orgchart_remove_company), Lucide.CircleOff) to
                    OrgAction.DeactivateCompany(directorId, managerId, companyId),
                OrgMenuOption(stringResource(Res.string.orgchart_manage_supervisors), Lucide.UserRoundCog) to
                    OrgAction.ManageSupervisors(companyId),
            )
        } else if (directorId.isNotEmpty()) {
            listOf(
                OrgMenuOption(stringResource(Res.string.orgchart_transfer_to), Lucide.ArrowRightLeft) to
                    OrgAction.TransferCompany(directorId, null, companyId),
                OrgMenuOption(stringResource(Res.string.orgchart_copy_to), Lucide.Copy) to
                    OrgAction.CopyCompany(directorId, null, companyId),
                OrgMenuOption(stringResource(Res.string.orgchart_unlink_director), Lucide.Unlink) to
                    OrgAction.UnlinkCompanyFromDirector(directorId, companyId),
                OrgMenuOption(stringResource(Res.string.orgchart_remove_company), Lucide.CircleOff) to
                    OrgAction.DeactivateCompany(directorId, null, companyId),
                OrgMenuOption(stringResource(Res.string.orgchart_manage_supervisors), Lucide.UserRoundCog) to
                    OrgAction.ManageSupervisors(companyId),
            )
        } else {
            listOf(
                OrgMenuOption(stringResource(Res.string.orgchart_set_responsible), Lucide.ArrowRightLeft) to
                    OrgAction.TransferCompany(directorId, null, companyId),
                OrgMenuOption(stringResource(Res.string.orgchart_remove_company), Lucide.CircleOff) to
                    OrgAction.DeactivateCompany(directorId, null, companyId),
                OrgMenuOption(stringResource(Res.string.orgchart_manage_supervisors), Lucide.UserRoundCog) to
                    OrgAction.ManageSupervisors(companyId),
            )
        }

    Box(
        modifier =
            Modifier
                .hoverable(interactionSource)
                .onGloballyPositioned { pillWindowPosition = it.positionInWindow() },
    ) {
        Surface(
            modifier =
                Modifier
                    .width(PillWidth)
                    .then(dragModifier)
                    .then(modifier),
            shape = pillShape,
            color = colors.container,
            contentColor = colors.content,
            border = colors.border?.let { BorderStroke(1.dp, it) },
        ) {
            Box(
                modifier = Modifier.padding(horizontal = AppSpacing.space16, vertical = AppSpacing.space8),
                contentAlignment = Alignment.Center,
            ) {
                Text(
                    text = text,
                    style =
                        if (emphasized) {
                            MaterialTheme.typography.titleSmall
                        } else {
                            MaterialTheme.typography.bodyMedium
                        },
                    textAlign = TextAlign.Center,
                    maxLines = 3,
                    overflow = TextOverflow.Ellipsis,
                )
            }
        }

        if ((hovered || menuExpanded) && (mode != ScreenMode.Read || menuItems.isNotEmpty())) {
            Box(
                modifier =
                    Modifier
                        .align(Alignment.TopEnd)
                        .padding(AppSpacing.space4),
            ) {
                IconButton(
                    onClick = { menuExpanded = true },
                    modifier = Modifier.size(24.dp),
                ) {
                    Icon(
                        imageVector = Lucide.EllipsisVertical,
                        contentDescription =
                            stringResource(
                                if (companyId == null) {
                                    Res.string.orgchart_manager_actions
                                } else {
                                    Res.string.orgchart_company_actions
                                },
                            ),
                        tint = MaterialTheme.colorScheme.onSurfaceVariant,
                    )
                }
                DropdownMenu(
                    expanded = menuExpanded,
                    onDismissRequest = { menuExpanded = false },
                ) {
                    menuItems.forEach { (option, action) ->
                        DropdownMenuItem(
                            text = { Text(option.label) },
                            leadingIcon = { Icon(option.icon, contentDescription = null) },
                            onClick = {
                                menuExpanded = false
                                onMenuAction(action)
                            },
                        )
                    }
                }
            }
        }
    }
}

@Composable
private fun TotalStat(
    value: String,
    label: String,
) {
    Column(verticalArrangement = Arrangement.spacedBy(AppSpacing.space4)) {
        Text(
            text = value,
            style = MaterialTheme.typography.headlineSmall,
            color = MaterialTheme.colorScheme.onSurface,
        )
        Text(
            text = label,
            style = MaterialTheme.typography.bodySmall,
            color = MaterialTheme.colorScheme.onSurfaceVariant,
        )
    }
}

@Composable
private fun ChangeLogPanel(changes: List<OrgChartChange>) {
    Surface(
        modifier = Modifier.fillMaxWidth(),
        shape = AppShapes.large,
        color = MaterialTheme.colorScheme.surface,
        border = BorderStroke(1.dp, MaterialTheme.colorScheme.outlineVariant),
    ) {
        Column(
            modifier =
                Modifier
                    .fillMaxWidth()
                    .padding(AppSpacing.space16),
            verticalArrangement = Arrangement.spacedBy(AppSpacing.space8),
        ) {
            Text(
                text = stringResource(Res.string.orgchart_changes_draft_title),
                style = MaterialTheme.typography.labelLarge,
                color = MaterialTheme.colorScheme.onSurfaceVariant,
            )
            ChangeLogList(changes)
        }
    }
}

@Composable
private fun ChangeLogList(changes: List<OrgChartChange>) {
    Column(
        modifier = Modifier.fillMaxWidth(),
        verticalArrangement = Arrangement.spacedBy(AppSpacing.space4),
    ) {
        changes.forEach { change ->
            Row(horizontalArrangement = Arrangement.spacedBy(AppSpacing.space8)) {
                Text(
                    text = "•",
                    style = MaterialTheme.typography.bodyLarge,
                    color = MaterialTheme.colorScheme.primary,
                )
                Text(
                    text = change.message(),
                    style = MaterialTheme.typography.bodyLarge,
                    color = MaterialTheme.colorScheme.onSurface,
                )
            }
        }
    }
}

@Composable
private fun ChangesDialog(
    title: String,
    changes: List<OrgChartChange>,
    emptyText: String,
    confirmLabel: String,
    onDismiss: () -> Unit,
    supportingText: String? = null,
    onConfirm: (() -> Unit)? = null,
) {
    ModalCard(title = title, onDismiss = onDismiss) {
        if (supportingText != null) {
            Text(
                text = supportingText,
                style = MaterialTheme.typography.bodyMedium,
                color = MaterialTheme.colorScheme.onSurfaceVariant,
            )
        }
        if (changes.isEmpty()) {
            Text(
                text = emptyText,
                style = MaterialTheme.typography.bodyMedium,
                color = MaterialTheme.colorScheme.onSurfaceVariant,
            )
        } else {
            ChangeLogList(changes)
        }
        if (onConfirm != null) {
            Row(horizontalArrangement = Arrangement.spacedBy(AppSpacing.space8)) {
                AppButton(
                    text = stringResource(Res.string.orgchart_cancel),
                    onClick = onDismiss,
                    variant = PortalButtonVariant.Outlined,
                    modifier = Modifier.weight(1f),
                )
                AppButton(
                    text = confirmLabel,
                    onClick = onConfirm,
                    variant = PortalButtonVariant.Accent,
                    modifier = Modifier.weight(1f),
                )
            }
        }
    }
}

@Composable
private fun LegendItem(
    color: Color,
    label: String,
) {
    Row(
        verticalAlignment = Alignment.CenterVertically,
        horizontalArrangement = Arrangement.spacedBy(AppSpacing.space8),
    ) {
        Box(
            modifier =
                Modifier
                    .size(12.dp)
                    .background(color, CircleShape),
        )
        Text(
            text = label,
            style = MaterialTheme.typography.bodySmall,
            color = MaterialTheme.colorScheme.onSurfaceVariant,
        )
    }
}

private data class OrgChartLegend(
    val color: Color,
    val label: String,
)

@Composable
private fun OrgChartVersion.subtitle(): String =
    when (status) {
        OrgChartStatus.Current ->
            stringResource(Res.string.orgchart_subtitle_published, number, publishedAt.orEmpty(), owner.orEmpty())
        OrgChartStatus.Legacy ->
            stringResource(Res.string.orgchart_subtitle_valid, number, effectiveFrom.orEmpty(), effectiveTo.orEmpty())
        OrgChartStatus.Draft ->
            stringResource(Res.string.orgchart_subtitle_edited, number, editedAt.orEmpty(), owner.orEmpty())
    }

@Composable
private fun OrgChartVersion.optionLabelText(): String {
    val period =
        if (effectiveTo == null) {
            stringResource(Res.string.orgchart_period_until_today, effectiveFrom.orEmpty())
        } else {
            stringResource(Res.string.orgchart_period, effectiveFrom.orEmpty(), effectiveTo)
        }
    val suffix = if (status == OrgChartStatus.Current) stringResource(Res.string.orgchart_version_current_suffix) else ""
    return "$number$suffix · $period"
}

@Composable
private fun ResponsibleOption.labelText(): String =
    when {
        managerId != null && directorName != null ->
            stringResource(Res.string.orgchart_responsible_pair, managerName.orEmpty(), directorName)
        managerId != null -> stringResource(Res.string.orgchart_responsible_no_director, managerName.orEmpty())
        else -> directorName.orEmpty()
    }

private fun joinNames(names: List<String>): String =
    when (names.size) {
        0 -> ""
        1 -> names[0]
        2 -> "${names[0]} e ${names[1]}"
        else -> "${names.dropLast(1).joinToString(", ")} e ${names.last()}"
    }

@Composable
private fun OrgChartChange.message(): String =
    when (this) {
        is OrgChartChange.DirectorAdded -> stringResource(Res.string.orgchart_change_director_added, name)
        is OrgChartChange.DirectorRemoved -> stringResource(Res.string.orgchart_change_director_removed, name)
        is OrgChartChange.ManagerAdded -> stringResource(Res.string.orgchart_change_manager_added, name)
        is OrgChartChange.ManagerRemoved -> stringResource(Res.string.orgchart_change_manager_removed, name)
        is OrgChartChange.ManagerRespondsTo -> stringResource(Res.string.orgchart_change_manager_responds, manager, director)
        is OrgChartChange.ManagerStoppedRespondingTo -> stringResource(Res.string.orgchart_change_manager_stopped, manager, director)
        is OrgChartChange.ManagerRespondsToAll ->
            stringResource(Res.string.orgchart_change_manager_responds_all, manager, joinNames(directors))
        is OrgChartChange.CompanyAdded -> stringResource(Res.string.orgchart_change_company_added, name)
        is OrgChartChange.CompanyRemoved -> stringResource(Res.string.orgchart_change_company_removed, name)
        is OrgChartChange.CompanyManagedBy ->
            stringResource(Res.string.orgchart_change_company_managed, company, joinNames(managers))
        is OrgChartChange.CompanyStoppedBeingManagedBy ->
            stringResource(Res.string.orgchart_change_company_stopped_managed, company, manager)
        is OrgChartChange.CompanyManagedByInDirectors ->
            if (directors.size == 1) {
                stringResource(Res.string.orgchart_change_company_managed_in_director, company, manager, directors.first())
            } else {
                stringResource(Res.string.orgchart_change_company_managed_in_directors, company, manager, joinNames(directors))
            }
        is OrgChartChange.CompanyStoppedBeingManagedByInDirectors ->
            if (directors.size == 1) {
                stringResource(Res.string.orgchart_change_company_stopped_managed_in_director, company, manager, directors.first())
            } else {
                stringResource(Res.string.orgchart_change_company_stopped_managed_in_directors, company, manager, joinNames(directors))
            }
        is OrgChartChange.CompanyLinkedToDirectors ->
            if (directors.size == 1) {
                stringResource(Res.string.orgchart_change_company_linked_director, company, directors.first())
            } else {
                stringResource(Res.string.orgchart_change_company_linked_directors, company, joinNames(directors))
            }
        is OrgChartChange.CompanyUnlinkedFromDirector ->
            stringResource(Res.string.orgchart_change_company_unlinked_director, company, director)
        is OrgChartChange.CompanyLinkedToOrganogram ->
            stringResource(Res.string.orgchart_change_company_linked_organogram, company)
        is OrgChartChange.CompanyUnlinkedFromOrganogram ->
            stringResource(Res.string.orgchart_change_company_unlinked_organogram, company)
    }

private data class BadgeColors(
    val container: Color,
    val content: Color,
)

@Composable
private fun OrgChartStatus.badgeColors(): BadgeColors =
    when (this) {
        OrgChartStatus.Current ->
            BadgeColors(
                container = PortalTheme.extraColors.successContainer,
                content = PortalTheme.extraColors.onSuccessContainer,
            )
        OrgChartStatus.Draft ->
            BadgeColors(
                container = PortalTheme.extraColors.warningContainer,
                content = PortalTheme.extraColors.onWarningContainer,
            )
        OrgChartStatus.Legacy ->
            BadgeColors(
                container = MaterialTheme.colorScheme.surfaceVariant,
                content = MaterialTheme.colorScheme.onSurface,
            )
    }
